(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-progress-bar"] && !Shopify.designMode) return;
  try {
    
class ShippingProgressBar extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.onCartUpdate = this.onCartUpdate.bind(this);
    this.updateLayout = this.updateLayout.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.ticking = false;
  }

  connectedCallback() {
    this.cacheRefs();
    this.updateLayout();
    window.addEventListener('resize', this.updateLayout);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    setTimeout(this.updateLayout, 500);
    setTimeout(this.updateLayout, 1500);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.updateLayout);
    window.removeEventListener('scroll', this.onScroll);
    if (this.unsubscribeCart) this.unsubscribeCart();
  }

  cacheRefs() {
    this.bar = this.querySelector('.shipping-progress-bar__bar');
    this.spacer = this.querySelector('.shipping-progress-bar__spacer');
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(() => {
      this.updateLayout();
      this.ticking = false;
    });
  }

  updateLayout() {
    if (!this.bar) return;

    var headerEl =
      document.querySelector('[id*="__header"]') ||
      document.querySelector('.shopify-section-header-sticky') ||
      document.querySelector('header');

    // Беремо РЕАЛЬНЕ поточне положення нижнього краю шапки на екрані —
    // це коректно враховує будь-яку CSS-анімацію показу/приховування шапки
    // при скролі (а не лише її статичну висоту при завантаженні).
    var topOffset = 0;
    if (headerEl) {
      var rect = headerEl.getBoundingClientRect();
      topOffset = Math.max(rect.bottom, 0);
    }
    this.bar.style.top = topOffset + 'px';

    var barHeight = this.bar.getBoundingClientRect().height;
    if (this.spacer && barHeight > 0) {
      this.spacer.style.height = barHeight + 'px';
    }
  }

  onCartUpdate() {
    fetch(`${window.location.pathname}?sections=${this.sectionId}`)
      .then((res) => res.json())
      .then((data) => {
        const html = data[this.sectionId];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const updated = doc.querySelector('shipping-progress-bar');
        if (updated) {
          this.innerHTML = updated.innerHTML;
          this.cacheRefs();
          this.updateLayout();
        }
      })
      .catch((err) => console.error('Shipping progress bar: update failed', err));
  }
}

if (!customElements.get('shipping-progress-bar')) {
  customElements.define('shipping-progress-bar', ShippingProgressBar);
}

  } catch(e) { console.error(e); }
})();
})();
